import { motion } from "framer-motion";

// Couture easing — slow, confident settle
const EASE = [0.2, 0.7, 0.2, 1];

// Single block reveal: gentle fade + slide-up as it scrolls into view.
export function Reveal({
  children,
  className = "",
  delay = 0,
  y = 34,
  duration = 0.95,
  once = true,
  ...props
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-70px" }}
      transition={{ duration, delay, ease: EASE }}
      {...props}
    >
      {children}
    </motion.div>
  );
}

// Container that staggers its <motion.*> children into view.
export const staggerContainer = (stagger = 0.08, delayChildren = 0.05) => ({
  hidden: {},
  visible: {
    transition: { staggerChildren: stagger, delayChildren },
  },
});

// Item variant for staggered lists/grids.
export const staggerItem = {
  hidden: { opacity: 0, y: 26 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

// Quiet fade + lift for images / single frames.
export const frameReveal = {
  hidden: { opacity: 0, y: 40, scale: 1.02 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1.1, ease: EASE },
  },
};

export { EASE };
